const dayFormat = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" })

export function courseDayScope(studioId, date) {
  try {
    const userId = JSON.parse(localStorage.getItem("user"))?.user?._id
    if (!localStorage.getItem("token") || !userId || !studioId || date !== dayFormat.format(new Date())) return null
    const rights = JSON.parse(localStorage.getItem("userRights"))?.userRights || []
    return JSON.stringify([userId, String(studioId), date, [...rights].sort()])
  } catch (_) { return null }
}

const pick = (value, fields) => Object.fromEntries(fields.filter((key) => value?.[key] !== undefined && (value[key] === null || typeof value[key] !== "object")).map((key) => [key, value[key]]))

// Only list display data, never participant records or complete populated documents.
export function compactCourseDay(courses) {
  return courses.map((course) => ({
    ...pick(course, ["_id", "courseTimelineId", "ts", "hours", "minutes", "duration", "amount", "signupAmount", "signedUp", "lsSignedUp", "onQueue", "queuePosition", "visited", "cancelled", "cancelledVisibility", "reqSignup", "icon", "additionalInfo", "isInstructor", "hoursClaimed"]),
    course: pick(course.course, ["_id", "name", "slimMe"]),
    room: pick(course.room, ["name"]),
    label: pick(course.label, ["text", "color"]),
    instructors: (course.instructors || []).map((instructor) => pick(instructor, ["vorname", "nachname"])),
    ratings: course.ratings ? pick(course.ratings, ["stars"]) : null,
    signups: Array.isArray(course.signups) ? course.signups.map(() => null) : undefined,
  }))
}

export function compactDaycare(settings, signups) {
  const days = {}
  for (const day of ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]) {
    days[day] = (Array.isArray(settings?.days?.[day]) ? settings.days[day] : []).map((slot) => pick(slot, ["isOpen", "open", "close"]))
  }
  return {
    settings: settings ? { active: Boolean(settings.active), notes: String(settings.notes || ""), days } : null,
    signups: {
      amount: Number(signups?.amount) || 0,
      signedUp: Boolean(signups?.signedUp),
      signedUpAmount: Number(signups?.signedUpAmount) || 0,
      signedUpBabiesAmount: Number(signups?.signedUpBabiesAmount) || 0,
      arrivalTime: signups?.arrivalTime || null,
    },
  }
}
